import { IconButton, Popover, Tooltip } from '@material-ui/core';
import FilterListIcon from '@mui/icons-material/FilterList';
import React, { useState } from 'react';

export const FilterToolbar = ({ children, openFilter, setOpenFilter }) => {
  const [hovered, setHovered] = useState(false);
  const buttonRef = React.useRef(null);

  return (
    <>
      <Tooltip
        title={'Filtrar tabla'}
        style={{ width: '40px', height: '40px' }}
        ref={buttonRef}
      >
        <IconButton
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();

            setOpenFilter(!openFilter);
          }}
        >
          <FilterListIcon
            style={{ color: hovered ? '#1976d2' : 'rgba(0, 0, 0, 0.54)' }}
          />
        </IconButton>
      </Tooltip>
      {openFilter && (
        <Popover
          open={openFilter}
          anchorEl={buttonRef.current}
          onClose={() => setOpenFilter(false)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          {children}
        </Popover>
      )}
    </>
  );
};
